// // variabls
// const initialProductCount = parseInt(document.querySelector(".product-list").dataset.initialProductCount);
// const productCards = Array.from(document.querySelectorAll(".it-product-card"));
// const hideProductCards = productCards.slice(initialProductCount, productCards.length);
// const loadMoreButton = document.getElementById("load-more");
//const loadPlans = document.getElementById("load-plans");
//const planAvailableText = document.getElementById("plan-available-text");

// // hiding product cards on load except initial count
// hideProductCards.forEach( (card) => {
//   card.style.display = "none";
// });

// // load more function
// loadMoreButton.addEventListener("click", () => {
//   if ( loadMoreButton.classList.contains("loaded") ) {
//     loadMoreButton.classList.remove("loaded");
//     loadMoreButton.innerText = "See member-only tests";
//     hideProductCards.forEach( (card) => {
//       card.style.display = "none";
//     });
//   } else {
//     loadMoreButton.classList.add("loaded");
//     loadMoreButton.innerText = "See less";
//     hideProductCards.forEach( (card) => {
//       card.style.display = "block";
//     });
//   }
// });

// load plan button action
// loadPlans.addEventListener("click", () => {
//   if ( loadPlans.classList.contains("checked") ) {
//     // productCards.forEach( (card) => {
//     //   card.style.display = "block";
//     // });
//     document.querySelectorAll(".it-product-list--wrapper.regional").forEach(function(el) => el.style.display = "block");
//     document.querySelector(".it-product-list--wrapper.international").forEach(function(el) => el.style.display = "none");
//     loadPlans.classList.remove("checked");
//     // if (initialProductCount !== productCards.length) {
//     //   loadMoreButton.style.display = "block";
//     //   loadMoreButton.classList.add("loaded");
//     //   loadMoreButton.innerText = "See less";
//     // }
//     planAvailableText.innerText = "Not in the US or Canada?";
//     window.scrollTo(0,0);
//   } else {
//     // productCards.forEach( (card) => {
//     //   card.style.display = "none";
//     //   if ( card.dataset.productTitle === "Blood Results Upload" || card.dataset.productTitle === "Blood Results Upload Subscription" || card.dataset.productTitle === "InsideTracker Membership" || card.dataset.productTitle === "InsideTracker Membership (Pro)" ) {
//     //     card.style.display = "block";
//     //     card.style.height = "fit-content";
//     //   } 
//     // });
//     document.querySelectorAll(".it-product-list--wrapper.regional").forEach(function(el) => el.style.display = "none");
//     document.querySelector(".it-product-list--wrapper.international").forEach(function(el) => el.style.display = "block");
//     loadPlans.classList.add("checked");
//     //loadMoreButton.style.display = "none";
//     planAvailableText.innerText = "In the US or Canada?";
//     window.scrollTo(0,0);
//   }
// });

// location based card
$.get("https://get.geojs.io/v1/ip/geo.js", function(response) {
  const userCountry = response.country_code;
  if (userCountry !== 'US' && userCountry !== "CA" && userCountry !== "BD") {
    // productCards.forEach( (card) => {
    //   card.style.display = "none";
    //   if ( card.dataset.productTitle === "Blood Results Upload" || card.dataset.productTitle === "Blood Results Upload Subscription" || card.dataset.productTitle === "InsideTracker Membership" || card.dataset.productTitle === "InsideTracker Membership (Pro)" ) {
    //     card.style.display = "block";
    //     card.style.height = "fit-content";
    //   } 
    // });
    //loadPlans.classList.add("checked");
    // loadMoreButton.style.display = "none";
    document.querySelectorAll("#load-plans").forEach(el => el.classList.add("checked"));
    document.querySelectorAll(".it-product-list--wrapper.regional").forEach(el => el.style.display = "none");
    document.querySelector(".it-product-list--wrapper.international").style.display = "block";
    document.querySelectorAll("#plan-available-text").forEach(el => el.innerText = "In the US or Canada?");
    document.querySelector(".component-hero--custom").style.display = "none";
    //planAvailableText.innerText = "In the US or Canada?";
  } 
}, "jsonp");

// hide load more button

// if (initialProductCount === productCards.length) {
//   loadMoreButton.style.display = "none";
// }